import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M21 2v6h-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 12a9 9 0 0 1 15-6.7L21 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 22v-6h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 12a9 9 0 0 1-15 6.7L3 16", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "RefreshCw";
const RefreshCw = memo(themed(Icon));
export {
  RefreshCw
};
//# sourceMappingURL=refresh-cw.js.map
